/* eslint-disable import/first */
// Suppress ResizeObserver errors globally - MUST BE AT THE TOP
(function () {
  const debounce = (callback: ResizeObserverCallback, delay: number) => {
    let tid: any;
    return function (entries: ResizeObserverEntry[], observer: ResizeObserver) {
      clearTimeout(tid);
      tid = setTimeout(() => callback(entries, observer), delay);
    };
  };

  const _ = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends _ {
    constructor(callback: ResizeObserverCallback) {
      super(debounce(callback, 20));
    }
  };

  // Also suppress the error message
  const e = window.console.error;
  window.console.error = (...args: any[]) => {
    if (
      args[0]?.includes?.('ResizeObserver') ||
      args[0]?.message?.includes?.('ResizeObserver')
    ) {
      return;
    }
    e(...args);
  };
})();

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
